<script lang="ts" setup>
import { NxtBugReport } from '@future-harry/nxt-styles';
import { storeToRefs } from 'pinia';
import { useUserInfoStore } from '../collections/user-info/user-info.store';

const userInfoStore = useUserInfoStore();
const { userInfo } = storeToRefs(userInfoStore);

const clickupFormUrl = import.meta.env.VITE_APP_CLICK_UP_FORM_URL;
const env = import.meta.env.VITE_APP_ENV;
</script>

<template>
   <div class="bug-report">
      <NxtBugReport v-if="userInfo" :url="clickupFormUrl" :env="env" :user-info="userInfo" :height="'100%'" />
   </div>
</template>

<style langs="scss" scoped>
.bug-report {
   width: 100%;
   height: 100%;
   overflow: auto;
}
</style>
